import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MembershipType, PaymentPlan } from '../../../../core/interfaces/payment-interfaces';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-payment-plan',
  standalone: true,
  imports: [CommonModule, CustomButtonComponent, TranslocoPipe],
  providers: [DecimalPipe],
  templateUrl: './payment-plan.component.html',
  styleUrl: './payment-plan.component.css'
})
export class PaymentPlanComponent {
  @Input() planInfo: PaymentPlan | null = null;
  @Input() billedYearly: boolean = true;

  showFullDescription = false;

  startPlan = MembershipType.START;
  smartPlan = MembershipType.SMART;

  @Output() onPlanSelected = new EventEmitter<any>();

  get monthlyPrice(): string {
    if (!this.planInfo) {
      return '-';
    }
    const rawAmount = this.billedYearly
      ? this.planInfo.price_per_year / 12
      : this.planInfo.price_per_month;

    return this.decimalPipe.transform(rawAmount, '1.2-2') || rawAmount.toString();
  }

  get translatedDescription(): string {
    if (this.planInfo?.membership_type == MembershipType.START) {
      return 'settings.start_desc';
    }
    else if (this.planInfo?.membership_type == MembershipType.SMART) {
      return 'settings.smart_desc'
    }
    return this.planInfo?.description || '-';
  }

  constructor(private decimalPipe: DecimalPipe) { }

  planSelected() {
    if (this.onPlanSelected) {
      this.onPlanSelected.emit();
    }
  }

  toggleDescription(): void {
    this.showFullDescription = !this.showFullDescription;
  }
}
